import moment from 'moment';
import AppConfig from '../config/AppConfig';

export default class DateUtil {

  static getFormattedTime(_time, format) {
    return moment(_time, 'H').format(format);
  }

  static addHours(date, hours) {
    let d = new Date();
    d.setHours(date.getHours() + hours);
    return d;

  }
  static getDefaultWorkHours() {
    if (AppConfig.getConfigParameter('lambda', 'default_work_hours'))
      return { ...AppConfig.getConfigParameter('lambda', 'default_work_hours') }
    return { work_hours_start: "07:00", work_hours_end: "17:00", include_weekends: '0' };
  }
  static getConfiguredWorkHours(site_selected) {
    let work_hours = {};
    if (site_selected && site_selected.site_config && site_selected.site_config.work_hours
      && site_selected.site_config.work_hours.work_hours_start && site_selected.site_config.work_hours.work_hours_end)
      work_hours = { ...site_selected.site_config.work_hours };

    if (!work_hours.work_hours_start || !work_hours.work_hours_end) {
      const default_work_hours = this.getDefaultWorkHours();
      work_hours = { ...default_work_hours };
    }

    if (!work_hours.include_weekends) {
      const default_work_hours = this.getDefaultWorkHours();
      work_hours = { ...work_hours, include_weekends: default_work_hours.include_weekends };
    }

    return { work_hours };
  }

  static getWorkHours({ work_hours_start, work_hours_end }, format) {
    let start = parseInt(work_hours_start.replace(":00", ""))
    let end = parseInt(work_hours_end.replace(":00", ""))
    const hours = [];
    for (let i = start; i <= end; i++) {
      hours.push(this.getFormattedTime(i, format));
    }
    return hours;
  }

  static getTimeSlotOptions(site_selected) {
    let { work_hours_start, work_hours_end } = this.getConfiguredWorkHours(site_selected).work_hours;
    const alertTimeSlotOptions = [];
    alertTimeSlotOptions.push({ value: '00:00,24:00', label: 'Always (default)', type: 'time_slot' });
    alertTimeSlotOptions.push({ value: `${work_hours_start},${work_hours_end}`, label: `Work Hours (${DateUtil.getFormattedTime(work_hours_start, "ha")} - ${DateUtil.getFormattedTime(work_hours_end, "ha")})`, type: 'time_slot' });
    alertTimeSlotOptions.push({ value: `${work_hours_end},${work_hours_start}`, label: `Off-Work Hours (${DateUtil.getFormattedTime(work_hours_end, "ha")} - ${DateUtil.getFormattedTime(work_hours_start, "ha")})`, type: 'time_slot' });
    return alertTimeSlotOptions;
  }

  static getDbData = function (tz, date) {
    var currentDateAt12AM = (date.length === 10) ? date + ' 00:00' : date; //moment().format('YYYY-MM-DD') + ' 00:00';
    var userTime = moment.tz(currentDateAt12AM, 'YYYY-MM-DD HH:mm', tz);
    var DBTime = userTime.tz('UTC');
    return DBTime.unix();
  }

  static getUnixTimeStampInUTC = function (timezone = 'America/Chicago', YYYY_MM_DD) {
    var start = moment(YYYY_MM_DD + "T00:00:00Z");
    var end = moment(YYYY_MM_DD + "T23:59:59Z");
    return [start.tz(timezone).unix(), end.tz(timezone).unix()];
  }
}